/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { SnackBarAlertContext } from "../../../contexts/SnackbarContext";
import { ErrorResponse, handleError } from "../../utils/errorHandler";
import request from "../../../request";
import axios from "axios";

const useMutation = (reDirectTo?: string) => {
  const snackBarAlertContext = useContext(SnackBarAlertContext);
  const navigate = useNavigate();
  const [response, setResponse] = useState<{
    loading: boolean;
    error: ErrorResponse | null;
  }>({
    loading: false,
    error: null,
  });
  const generateApiCall = async (
    endPoint: string,
    requestType: "post" | "put" | "patch" | "delete",
    variables?: any,
    signal?: AbortSignal
  ) => {
    switch (requestType) {
      case "post":
        return request.post(endPoint, variables, { signal });
      case "put":
        return request.put(endPoint, variables, { signal });
      case "patch":
        return request.patch(endPoint, variables, { signal });
      case "delete":
        return request.delete(endPoint, { data: variables, signal });
    }
  };

  const modifyData = useCallback(
    async (
      endPoint: string,
      requestType: "post" | "put" | "patch" | "delete",
      variables?: any,
      showSnackBar: boolean = true,
      signal?: AbortSignal,
      formInstance?: any,
    ) => {
      try {
        setResponse({ loading: true, error: null });

        let apiResponse = await generateApiCall(
          endPoint,
          requestType,
          variables,
          signal
        );

        setResponse({ loading: false, error: null });

        if (showSnackBar) {
          snackBarAlertContext.set({
            status: true,
            type: "success",
            message: apiResponse?.data?.message,
          });
        }

        if (reDirectTo) navigate(reDirectTo);

        return apiResponse?.data;
      } catch (error: any) {

        if (axios.isCancel(error)) {
          throw error;
        }

        setResponse({ loading: false, error: error as ErrorResponse });

        if (formInstance) {
          handleError(
            formInstance,
            error as ErrorResponse,
            showSnackBar ? snackBarAlertContext : undefined
          );
        } else if (showSnackBar) {
          snackBarAlertContext.set({
            status: true,
            type: "error",
            message: error.message,
          });
        }
        throw error;
      }
    },
    [navigate, reDirectTo, snackBarAlertContext]
  );

  return { ...response, modifyData };
};

export default useMutation;

